import { render, staticRenderFns } from "./IconCompass.vue?vue&type=template&id=7e3548af&"
import script from "./IconCompass.vue?vue&type=script&lang=js&"
export * from "./IconCompass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports